<template>
  <b-container fluid class="course_card" @click="viewCourse"
    ><b-row>
      <b-col class="top_bar" :style="{ background: course.color }">
      </b-col> </b-row
    ><b-row>
      <b-col>
        <h3 class="course_name">
          <span>{{ course.courseId }}</span>
          <span class="alert-container">
            <i
              title="Session report due"
              class="fa fa-exclamation-circle alert-icon"
              v-b-tooltip.hover="{ customClass: 'tsny_tooltip' }"
              v-if="!isStudent && reportDue"
            />
          </span>
        </h3>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <h2 class="tsny_header">
          {{ name }}
        </h2></b-col
      >
    </b-row>
    <b-row class="mb-n1">
      <b-col>
        <div class="tsny_text text-dark">{{ phone }}</div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="tsny_text text-dark">{{ email }}</div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import StoreConstants from "../../store/services/StoreConstants";
import { mapGetters } from "vuex";

export default {
  name: "CourseCard",
  props: {
    course: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapGetters({
      isStudent: StoreConstants.GETTERS.IS_STUDENT,
      reportDueGetter: StoreConstants.GETTERS.IS_SESSION_REPORT_DUE
    }),
    reportDue: function() {
      return this.reportDueGetter(this.course._id);
    },
    name: function() {
      return this.isStudent
        ? `${this.course.tutor.first} ${this.course.tutor.last}`
        : `${this.course.student.first} ${this.course.student.last}`;
    },
    phone: function() {
      return this.isStudent
        ? `${this.course.tutor.phone}`
        : `${this.course.student.phone}`;
    },
    email: function() {
      return this.isStudent
        ? `${this.course.tutor.email}`
        : `${this.course.student.email}`;
    }
  },
  methods: {
    viewCourse: function() {
      this.$router.push({
        name: "Course",
        params: { id: this.course._id }
      });
    }
  }
};
</script>

<style scoped>
.course_card {
  text-align: center;
}

.course_card:hover {
  cursor: pointer;
}

.course_name {
  font-family: eskorte-latin, serif;
  font-weight: bold;
  font-size: 2.5em;
  margin-top: 35px;
  margin-bottom: 35px;
}

.alert-container {
  position: absolute;
  padding-left: 0.25em;
  padding-top: 0.35em;
  font-size: 0.7em;
}

.alert-icon:hover {
  color: #c83a4a;
}
</style>
